import React from "react";
import "./index.scss";
import {strings} from "../../../strings/strings";

export const TravelHeader = () => {

    return (
        <div className={"travel-header"}>
            <div className={'travel-header__title'}>
                <span className={'name'}>{strings.travel.header.name}</span>
                <span className={'description'}>{strings.travel.header.description}</span>
            </div>
        </div>
    )
};